import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step2_1 from "@/assets/integration-steps/tiktok/step_2_1.png";
import step2_2 from "@/assets/integration-steps/tiktok/step_2_2.png";
import step2_3 from "@/assets/integration-steps/tiktok/step_2_3.png";
import step2_4 from "@/assets/integration-steps/tiktok/step_2_4.png";
import step2_5 from "@/assets/integration-steps/tiktok/step_2_5.png";

interface Props {
  stepLabel?: string;
}

const TikTokIntegrationStep2 = ({ stepLabel }: Props) => {
  return (
    <div className="channels-integration-step tiktok-step-2">
      <div className="step-label-row">
        {stepLabel && <OpticksNumberCircle number={stepLabel} />}
        <h6>Create the exclusion audience in TikTok</h6>
      </div>
      <div className="step-label-row">
        <p>
          First you will need to create an Audience that Opticks will fill with
          the visitors to be excluded.
        </p>
      </div>
      <p>
        Go to the Audience Manager section in the tools menu, and start the
        Audience creation process by{" "}
        <b>
          clicking on the button "Create Audience" and choose a "Custom
          Audience", and then select "Website traffic" as the audience type.
        </b>
      </p>

      <img src={step2_1} alt="Screenshot of step 2.1 TikTok Integration" />
      <img src={step2_2} alt="Screenshot of step 2.2 TikTok Integration" />
      <img src={step2_3} alt="Screenshot of step 2.3 TikTok Integration" />
      <div>
        You will need to fill or change the following fields:
        <ol>
          <li>
            <p>
              "People who've carried the following actions": unselect "Page
              View", and then select "OpticksExcludeVisitor" event. <b>Note:</b>
              "OpticksExcludeVisitor" only will appear after some events have
              been sent by the Opticks script, so it may take some time to
              appear.
            </p>
          </li>
          <li>
            <p>"in the past": select 180 days (which is the maximum)</p>
          </li>
          <li>
            <p>
              "Through the following pixels": select the TikTok pixel(s) that
              you already use, or that you created in the previous step
            </p>
          </li>
        </ol>
      </div>

      <img src={step2_4} alt="Screenshot of step 2.4 TikTok Integration" />
      <ol start={4}>
        <li>
          <p>
            "Audience name": We recommend "Opticks Negative Audience", but you
            can use any name.
          </p>
        </li>
      </ol>
      <p> After that, click on the "Confirm" button.</p>
      <img src={step2_5} alt="Screenshot of step 2.5 TikTok Integration" />
    </div>
  );
};

export default TikTokIntegrationStep2;
